import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import CommunitiesListBig from '../../../../components/reusable/communities-list/CommunitiesListBig';
import { CommunitiesListRefreshProvider } from '../../../../components/reusable/communities-list/CommunitiesListRefreshContext';
import withRouter from '../../../../hoc/with-router';
import { useNotFound } from '../../../../hooks/useNotFound';
import { useGetUserCommunities } from '../../../../redux/api/users/usersApi';
import { useStyles } from './UserCommunites.styles';

function UserCommunities(props) {
  const { params } = props;
  const { t, i18n } = useTranslation();
  const {
    data: communities,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetUserCommunities(params.userId);
  useNotFound(!isFetching && !communities);
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  useRegisterPageContainerError({
    errors: isError && error ? [error] : [],
    isLoading: isFetching && communities === undefined,
    hasData: Boolean(communities?.length),
    onRetry: handleRetry,
  });

  return (
    <PageContainer
      title={t('users.communities')}
      backButton
      onRefresh={() => void refetch()}>
      <div className={classes.communitiesWrapper}>
        <CommunitiesListRefreshProvider refetch={() => void refetch()}>
          <CommunitiesListBig
            communities={communities}
            showSearch
            withoutTabs
            isLoading={isFetching && communities === undefined}
            isError={isError}
          />
        </CommunitiesListRefreshProvider>
      </div>
    </PageContainer>
  );
}

export default withRouter(UserCommunities);
